import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const financialDocumentHostStyleId = 'wb-v2-surface-financial-document-host-theme';

export const financialDocumentHostBridgeStyles = {
  'wb-surface-financial-document-host': {
    // Canvas + document sheet.
    '--local-fd-canvas-bg': tokens.color.background.secondary,
    '--local-fd-sheet-bg': tokens.color.background.primary,
    '--local-fd-sheet-border': tokens.color.border.tertiary,
    '--local-fd-sheet-ring': 'rgba(10, 13, 18, 0.06)',

    // Rule between the party cards and the Delivery block.
    '--local-fd-section-divider': tokens.color.border.secondary,

    // Rail / dock.
    '--local-fd-rail-border': tokens.color.border.secondary,
    '--local-fd-rail-bg': tokens.color.background.primary,
    '--local-fd-rail-content-padding': tokens.spacing.xl,
    // Between cards of a plain relation list in the rail (Payments).
    '--local-fd-rail-list-gap': tokens.spacing.mdAlt,
    '--local-fd-rail-shadow': '-8px 0 24px rgba(10, 13, 18, 0.08)',

    // Text.
    '--local-fd-text-primary': tokens.color.text.primary,
    '--local-fd-text-secondary': tokens.color.text.secondary,
    '--local-fd-text-tertiary': tokens.color.text.tertiary,
    '--local-fd-link': tokens.color.text.brandSecondary,
    // Same mark as wb-field's required asterisk (error700). Brand reads as a second color on the date label.
    '--local-fd-required': tokens.componentColors.utility.error700,

    // Error banner.
    '--local-fd-error-bg': tokens.color.background.errorPrimary,
    '--local-fd-error-border': tokens.color.border.error,
    '--local-fd-error-text': tokens.color.text.errorPrimary,

    // Customer / supplier reference. Wider than the date slots; a longer PO still clips.
    // Readonly shows the rest in a tooltip (WBS-11328).
    '--local-fd-meta-reference-width': '240px',

    // Inputs.
    '--local-fd-input-border': tokens.color.border.primary,
    '--local-fd-input-bg': tokens.color.background.primary,
    '--local-fd-input-hover-border': tokens.color.border.secondaryAlt,
    '--local-fd-input-focus-border': tokens.color.border.brand,
    '--local-fd-input-focus-ring': tokens.focusRing.default,

    // Party (from/to) cards.
    '--local-fd-party-border': tokens.color.border.secondary,
    '--local-fd-party-bg': tokens.color.background.primary,
    '--local-fd-avatar-text': tokens.color.text.white,
    '--local-fd-avatar-from': tokens.componentColors.utility.purple500,
    '--local-fd-avatar-to': tokens.componentColors.utility.blueLight500,

    // Price summary — values taken from Figma node 4610:80396 (Invoice/Invoice Summary).
    // Filled panel, no heading, dashed rule under the tax control, and a total emphasised by
    // the display face at display-xs rather than by a rule above it.
    '--local-fd-summary-bg': tokens.color.background.secondary,
    '--local-fd-summary-border': tokens.color.border.secondary,
    '--local-fd-summary-radius': tokens.radius.md,
    '--local-fd-summary-padding': tokens.spacing.xl,
    // Gap BETWEEN rows; label↔value spacing is the tighter --local-fd-summary-pair-gap.
    '--local-fd-summary-row-gap': tokens.spacing.lg,
    '--local-fd-summary-pair-gap': tokens.spacing.md,
    '--local-fd-summary-label': tokens.color.text.secondary,
    '--local-fd-summary-value': tokens.color.text.primary,
    // Quote Buy|Sell figures. Legacy `--colors-blue-800` / `--colors-green-800`; package ramps stop at success-700.
    '--local-fd-summary-buy': tokens.componentColors.utility.brand800,
    '--local-fd-summary-sell': tokens.componentColors.utility.success700,
    '--local-fd-summary-lane-header': tokens.color.text.quaternary,
    '--local-fd-summary-font-family': tokens.font.family.body,
    '--local-fd-summary-font-size': tokens.font.size.textMdBase,
    '--local-fd-summary-line-height': tokens.lineHeight.textMd,
    '--local-fd-summary-label-weight': tokens.font.weight.regular,
    '--local-fd-summary-value-weight': tokens.font.weight.medium,
    // Figma tracks the figures at -0.13px; -0.01em is the same at 13px and scales with the font.
    '--local-fd-summary-value-tracking': '-0.01em',
    '--local-fd-summary-divider': tokens.color.border.secondary,
    '--local-fd-summary-total-text': tokens.color.text.primary,
    '--local-fd-summary-total-family': tokens.font.family.display,
    '--local-fd-summary-total-size': tokens.font.size.displayXs,
    '--local-fd-summary-total-line-height': tokens.lineHeight.displayXs,
    '--local-fd-summary-total-weight': tokens.font.weight.semibold,
    // The total's label stays body-regular at text-md and is capped so it never crowds the figure.
    '--local-fd-summary-total-label-max': '100px',
    // The prepayment row's tax breakdown is an annotation on the figure above it, so it drops a
    // step in size and colour rather than reading as a second figure.
    '--local-fd-summary-note-size': tokens.font.size.textXs,
    '--local-fd-summary-note-text': tokens.color.text.tertiary,
  },
};
